// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');
'use strict';
module.exports = require('./').polyfill();



//////////////////
// WEBPACK FOOTER
// ./~/es6-promise/auto.js
// module id = 396
// module chunks = 0